const MINUTE_MS = 60_000;
const BASELINE_ONLINE = 50;
const HASH_RANGE = 50;

/**
 * Present a lively public population without changing the authoritative
 * connection count used by health checks and operations.
 */
export function publicOnlineCount(
  connectedPlayers: number,
  nowMs = Date.now(),
): number {
  let hash = Math.floor(nowMs / MINUTE_MS) | 0;
  hash = Math.imul(hash ^ (hash >>> 16), 0x45d9f3b);
  hash = Math.imul(hash ^ (hash >>> 16), 0x45d9f3b);
  hash ^= hash >>> 16;
  return BASELINE_ONLINE + ((hash >>> 0) % HASH_RANGE) + connectedPlayers * 2;
}
